import { all, call, put, takeLatest, select } from "redux-saga/effects";
import { actionCreators, actionTypes } from "./actions";
import { get, set } from "idb-keyval";
import { db } from "../../common/lib/";
import { logToSentry } from "../../config/Sentry";

function* searchRequest(action) {
    try {
        const { audits } = yield select((state) => state);
        const { searchValue } = action.payload;
        const { id } = audits.item;
        let cachedData = (yield call(get, db.types.searchCache)) || [];
        let assets = (yield call(get, db.types.auditAsset)) || [];

        const results = db.queries.searchAssetFilter(
            searchValue,
            assets,
            cachedData,
            id
        );

        yield put(actionCreators.searchSuccess(results));
    } catch (error) {
        const errStr = error.toString();
        logToSentry("search request", {
            error,
            errStr,
        });
    }
}

export { searchRequest };

export default (function* () {
    yield all([takeLatest(actionTypes.SEARCH_STATE_REQUEST, searchRequest)]);
})();
